import { atom } from "jotai";

import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "@/i18n/config";

function getInitialCulture(): SupportedLanguage {
  if (typeof window === "undefined") {
    return "en";
  }

  const storedLanguage = window.localStorage.getItem("priorityOSLng");
  if (
    storedLanguage &&
    SUPPORTED_LANGUAGES.includes(storedLanguage as SupportedLanguage)
  ) {
    return storedLanguage as SupportedLanguage;
  }

  const browserLanguage = window.navigator.language.split(
    "-",
  )[0] as SupportedLanguage;

  return SUPPORTED_LANGUAGES.includes(browserLanguage) ? browserLanguage : "en";
}

export const cultureAtom = atom<SupportedLanguage>(getInitialCulture());
